import { Offer } from '@n2-common/serverGeneratedTypings/offer';
import { OfferBoxProps, OfferBox as OfferBoxComponent } from '../../../../common/components/OfferBox';
import { formatPercent } from '../../../../common/lib/interestRate';
import { formatWithCurrencyNoDecimals, getCurrencyCode } from '../../../../common/lib/money';

export function OfferBox({ offer }: { offer: Offer }): JSX.Element {
    const years = offer.NumberOfTerms ? `${(offer.NumberOfTerms / 12).toString()} år` : "";
    const props: OfferBoxProps = {
        heading: 'LÅNEBELØP:',
        amount: offer.LoanAmount || 0,
        currency: getCurrencyCode('NO'),
        subHeading: undefined,
        details: [
            {
                label: 'Månedlig beløp',
                data: formatWithCurrencyNoDecimals(offer.MinimumToPay, 'NO'),
            },
            { label: 'Løpetid', data: years },
            { label: 'Nominell rente', data: formatPercent(offer.NominalInterestRate) },
            { label: 'Effektiv rente',data: formatPercent(offer.EffectiveInterestRate), 
            },
            { label: 'Etableringsgebyr', data: formatWithCurrencyNoDecimals(offer.EstablishmentFee, 'NO') },
            { label: 'Termingebyr', data: formatWithCurrencyNoDecimals(offer.InstallmentCharge, 'NO') },
           
        ],
    };
    return <OfferBoxComponent {...props} />;
}
